<template>
  <div class="my-5 md:my-0 max-w-screen-md mx-auto">
    <div class="flex flex-col py-3">
      <div class="md:rounded-xl shadow-lg bg-white flex flex-col px-3 py-2 md:px-8 md:py-5 my-5">
        <div class="flex items-center">
          <div class="flex rounded items-center justify-center px-3 bg-brand-blue w-8 mr-5">
            <h4 class="text-white">i</h4>
          </div>
          <h4 class="py-1">Select the reports you'd like to receive</h4>
        </div>
        <p class="py-3 text-brand-dark-gray">
          All reports are free to you as the landlord; applicants pay the cost. You can edit these
          settings later. We highly recommend all verification reports as they protect you from the
          rising risk of applicant fraud.
        </p>
      </div>

      <div
        class="md:rounded-xl shadow-lg bg-white flex flex-col px-3 py-2 md:px-8 md:py-5 my-5"
        v-if="fraudProfiles && fraudProfiles.length"
      >
        <div class="flex flex-col mb-5">
          <div class="flex items-center">
            <h4 class="">Fraud Prevention Reports</h4>
            <div class="rounded bg-brand-purple flex items-center ml-3 py-0.5 px-2 relative">
              <p class="absolute -top-2 -left-2 text-xs">🔥</p>
              <p class="text-dark-gray text-xs">New</p>
            </div>
          </div>
          <p class="py-3 text-brand-dark-gray">
            Catch fraudulent applicants trying to apply with stolen identities and forged financial
            documents.
          </p>
        </div>
        <div class="flex flex-row py-2" v-for="rsp in fraudProfiles" :key="rsp.id">
          <div class="pr-5">
            <input
              :id="`rsp-checkbox-option-${rsp.id}`"
              type="checkbox"
              class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-5 h-5"
              v-model="selected[rsp.source_identifier]"
              :disabled="!rsp.active"
            />
          </div>

          <div class="flex flex-col w-full">
            <div class="flex flex-row">
              <div class="flex items-center">
                <label :for="`rsp-checkbox-option-${rsp.id}`">
                  {{ rsp.select_report_label }}
                </label>
                <!-- <div class="flex items-center relative">
                  <div
                    @click.self="toggleTooltip(`rsp-${rsp.id}`)"
                    @mouseenter="toggleTooltip(`rsp-${rsp.id}`)"
                    @mouseleave="toggleTooltip(`rsp-${rsp.id}`)"
                  >
                    <QuestionMarkCircleIcon
                      class="w-5 h-5 ml-1 text-brand-mid-gray"
                      :id="`rsp-${rsp.id}`"
                    />
                  </div>

                  <div
                    :class="[
                      'w-64 py-2 px-2 text-xs mt-2 bg-gray-600 text-gray-100 absolute right-24 px-1 rounded bg-opacity-50 shadow-xl',
                      tooltip[`rsp-${rsp.id}`] ? 'inline-block' : 'hidden'
                    ]"
                  >
                    {{ rsp.tooltip_label }}
                  </div>
                </div> -->

                <div class="rounded bg-brand-purple flex items-center ml-3 py-0.5 px-2 relative">
                  <p class="absolute -top-2 -left-2 text-xs">🔥</p>
                  <p class="text-dark-gray text-xs">New</p>
                </div>

                <p class="text-brand-blue ml-3">${{ rsp.price }} cost to applicant</p>
              </div>
            </div>
            <p
              v-if="rsp.source_identifier === 'experian_credit'"
              class="text-brand-dark-gray text-xs py-1 italic"
            >
              {{
                rsp.active ? rsp.process_label : "To select the credit report option you need to "
              }}
              <router-link
                v-if="!rsp.active"
                :to="{ name: 'dashboard_verify_disclaimer' }"
                class="text-brand-green hover:underline font-semibold not-italic"
                >Verify your Identify through Experian</router-link
              >
            </p>

            <p
              v-if="rsp.source_identifier !== 'experian_credit'"
              class="text-brand-dark-gray text-xs py-1 italic"
            >
              {{ rsp.process_label }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="md:rounded-xl shadow-lg bg-white flex flex-col px-3 py-2 md:px-8 md:py-5 my-5"
        v-if="screeningProfiles && screeningProfiles.length"
      >
        <div class="flex flex-col mb-5">
          <h4 class="">Screening Reports</h4>
          <p class="py-3 text-brand-dark-gray">
            These are reports designed to collect useful information about your applicants.
          </p>
        </div>
        <div class="flex flex-row py-2" v-for="rsp in screeningProfiles" :key="rsp.id">
          <div class="pr-5">
            <input
              :id="`rsp-checkbox-option-${rsp.id}`"
              type="checkbox"
              class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-5 h-5"
              v-model="selected[rsp.source_identifier]"
              :disabled="!rsp.active"
            />
          </div>

          <div class="flex flex-col w-full">
            <div class="flex flex-row">
              <div class="flex items-center">
                <label :for="`rsp-checkbox-option-${rsp.id}`">
                  {{ rsp.select_report_label }}
                </label>
                <!-- <div class="flex items-center relative">
                  <div
                    @click.self="toggleTooltip(`rsp-${rsp.id}`)"
                    @mouseenter="toggleTooltip(`rsp-${rsp.id}`)"
                    @mouseleave="toggleTooltip(`rsp-${rsp.id}`)"
                  >
                    <QuestionMarkCircleIcon
                      class="w-5 h-5 ml-1 text-brand-mid-gray"
                      :id="`rsp-${rsp.id}`"
                    />
                  </div>

                  <div
                    :class="[
                      'w-64 py-2 px-2 text-xs mt-2 bg-gray-600 text-gray-100 absolute right-24 px-1 rounded bg-opacity-50 shadow-xl',
                      tooltip[`rsp-${rsp.id}`] ? 'inline-block' : 'hidden'
                    ]"
                  >
                    {{ rsp.tooltip_label }}
                  </div>
                </div> -->

                <p class="text-brand-blue ml-3">${{ rsp.price }} cost to applicant</p>
              </div>
            </div>
            <p
              v-if="rsp.source_identifier === 'experian_credit'"
              class="text-brand-dark-gray text-xs py-1 italic"
            >
              {{
                rsp.active ? rsp.process_label : "To select the credit report option you need to "
              }}
              <router-link
                v-if="!rsp.active"
                :to="{ name: 'dashboard_verify_disclaimer' }"
                class="text-brand-green hover:underline font-semibold not-italic"
                >Verify your Identify through Experian</router-link
              >
            </p>

            <p
              v-if="rsp.source_identifier !== 'experian_credit'"
              class="text-brand-dark-gray text-xs py-1 italic"
            >
              {{ rsp.process_label }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="md:rounded-xl shadow-lg bg-white flex flex-col px-3 py-2 md:px-8 md:py-5 my-5">
      <div class="flex flex-col py-3" v-if="getCurrentUser.landlord.payments_enabled">
        <div class="flex flex-row justify-between">
          <div class="flex items-center">
            <h5>
              Additional Application Fee
              <span class="text-xs text-brand-mid-gray md:ml-1">(optional)</span>
            </h5>
          </div>
          <div class="flex flex-row items-center justify-end">
            <div class="border border-brand-mid-gray rounded-tl rounded-bl py-1 md:py-2 pl-5 pr-3">
              <p class="">$</p>
            </div>
            <div class="md:w-24">
              <input
                type="number"
                min="1"
                max="100"
                step="0.01"
                class="w-full px-4 text-sm md:text-base rounded-tr rounded-br border border-brand-mid-gray border-l-0 placeholder-brand-mid-gray focus:border-brand-green focus:ring-brand-green"
                placeholder="0.00"
                :class="{ 'bg-brand-light-gray': !!fee }"
                v-model="fee"
                @change="validateFee"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-col md:w-2/3 pt-2 md:pt-0">
          <p class="text-xs text-brand-mid-gray">
            Add on an extra fee from $1 up to $100 on top of the reports base fee.
          </p>
          <p class="text-xs text-brand-mid-gray">
            Fees will be accrued in your My payments account.
          </p>
          <p class="text-xs text-brand-mid-gray">
            For fees over $100, please contact support@rentapplication.net.
          </p>
        </div>
      </div>

      <div class="flex flex-col py-5">
        <div class="flex flex-row justify-between">
          <div class="flex items-center">
            <h5 class="text-lg">Total Fee Paid by Applicant</h5>
          </div>
          <div class="flex items-center">
            <h5 class="text-lg font-semibold md:pr-10">${{ totalFee }}</h5>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col py-3"
        v-if="!hasReportsSelected && !getCurrentUser.landlord.verified"
      >
        <AlertToast>
          <div class="py-3 px-3">
            <p>
              Warning: Not requesting any reports will show applicants a warning when opening an
              application. Click
              <router-link :to="{ name: 'home_applicant_warning_message' }" class="text-brand-green"
                >here</router-link
              >
              to learn why we do this
            </p>
          </div>
        </AlertToast>
      </div>

      <div class="flex flex-col justify-between py-5">
        <div class="w-full md:w-1/3 mx-auto py-1">
          <PrimaryButton @click="navigateNext">Next </PrimaryButton>
        </div>
        <p @click="backToDashboard" class="text-brand-green text-center mt-8 cursor-pointer">
          Cancel
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash"
import { mapGetters } from "vuex"

import { APPLICATION_TEMPLATE_SET_NEW } from "@/store/types"

// import { QuestionMarkCircleIcon } from "@heroicons/vue/outline"

export default {
  components: {
    // QuestionMarkCircleIcon
  },
  computed: {
    ...mapGetters(["getCurrentUser", "getCurrentNewApplicationTemplate"]),
    hasReportsSelected() {
      return _.some(Object.values(this.selected))
    },
    totalFee() {
      return (
        parseFloat(this.fee || 0) +
        Object.keys(this.selected)
          .map((key) => {
            if (this.selected[key]) {
              return parseFloat(this.profiles.find((rsp) => rsp.source_identifier === key).price)
            }
            return 0
          })
          .reduce((total, v) => total + v, 0)
      ).toFixed(2)
    },
    screeningProfiles() {
      if (!this.profiles) {
        return []
      }
      const identifiers = [
        "credit",
        "criminal",
        "eviction",
        "current_landlord",
        "previous_landlord"
      ]
      return this.profiles.filter((rsp) => identifiers.includes(rsp.type))
    },
    fraudProfiles() {
      if (!this.profiles) return []

      const identifiers = ["identity", "income", "employment"]

      return this.profiles.filter((rsp) => identifiers.includes(rsp.type))
    }
  },
  data() {
    return {
      selected: {},
      tooltip: {},
      slugErrorMessage: "",
      profiles: null,
      fee: 0
    }
  },
  mounted() {
    this.profiles = _.orderBy(
      this.getCurrentUser.report_source_profiles.map((rsp) => {
        if (rsp.source_identifier.includes("credit")) {
          rsp.process_label = "Typically processed within 5 minutes. Soft inquiry on credit file."
          rsp.order = 1

          if (rsp.source_identifier.includes("experian")) {
            rsp.select_report_label = "Credit Report by Experian"
            rsp.tooltip_label =
              "Comprehensive credit reporting including Vantage score, detailed trade line information, public records, and more provided by Experian"
          } else if (rsp.source_identifier.includes("zip_report")) {
            rsp.select_report_label = "Credit Report by Transunion"
            rsp.tooltip_label =
              "Comprehensive credit reporting including Vantage score, detailed trade line information, public records, and more provided by Transunion"
          } else {
            rsp.select_report_label = "Credit Report by Transunion"
            rsp.tooltip_label =
              "Comprehensive credit reporting including FICO score, detailed trade line information, public records, and more provided by Transunion"
          }
        }

        if (rsp.source_identifier.includes("criminal")) {
          rsp.select_report_label = "Criminal Record Search"
          rsp.order = 3
          rsp.process_label = "Typically processed within 5 minutes"
          rsp.tooltip_label =
            "Criminal background search of over 500 MILLION records from all 50 states and includes a bonus FREE search of sex and violent offender criminal records and terrorist check"
        }

        if (rsp.source_identifier.includes("eviction")) {
          rsp.select_report_label = "Evictions, Judgements, and Liens"
          rsp.order = 4
          rsp.process_label = "Typically processed within 5 minutes"
          rsp.tooltip_label =
            "Database of millions of public records for eviction filings, liens, civil suits, and judgements. This report may disclose additional information about a prospective tenant that would not always show up on a credit report or criminal background check. Supports all 50 states, but county coverage may vary."
        }

        if (rsp.source_identifier.includes("employment")) {
          rsp.select_report_label = "Employment Verification"
          rsp.order = 2
          rsp.process_label = "Typically processed within 3 business days"
          rsp.tooltip_label =
            "We contact the applicant’s stated employer to confirm their status and other details about their employment. Because this report requires the current employer’s participation, reports may be delayed up to 3 business days. If after 3 business days the employer does not respond to our inquiry, the inquiry will be closed."

          if (rsp.source_identifier.includes("plus")) {
            rsp.select_report_label = "Income Verification +"
            rsp.tooltip_label =
              "We contact the applicant’s stated employer to confirm their status and other details about their employment. Applicant can also verify their income by connecting their bank account. Because this report requires the current employer’s and applicant's participation, reports may be delayed up to 3 business days. If after 3 business days the employer does not respond to our inquiry, the inquiry will be closed."
          }
        }

        if (rsp.source_identifier.includes("identity")) {
          rsp.select_report_label = "Identity Verification"
          rsp.order = 0
          rsp.process_label =
            "Typically processed within few minutes after applicant completes the verification"
          rsp.tooltip_label =
            "Automated identity verification that looks for patterns to determine if an ID document is real or fake. Also captures real-time photos of the applicant to match them with the ID document."
        }

        if (rsp.source_identifier.includes("landlord")) {
          rsp.process_label = "Typically processed within 3 business days"
          const type = rsp.source_identifier.includes("previous") ? "previous" : "current"
          rsp.tooltip_label = `We confirm the applicant’s residence and reputation with the primary contact at their ${type} address. Because this report requires the #{type} landlord’s participation, reports may be delayed up to 3 business days. If after 3 business days the #{type} landlord does not respond to our inquiry, the inquiry will be closed.`

          if (
            rsp.source_identifier.includes("current") ||
            rsp.source_identifier === "mvga_landlord"
          ) {
            rsp.select_report_label = "Current Residence Verification"
            rsp.order = 5
          } else {
            rsp.select_report_label = "Previous Residence Verification"
            rsp.order = 6
          }
        }
        return rsp
      }),
      ["order"]
    )

    if (this.getCurrentNewApplicationTemplate) {
      this.fee = this.getCurrentNewApplicationTemplate.fee
      this.getCurrentNewApplicationTemplate.selected.forEach((rsp) => {
        this.selected[rsp] = true
      })
    } else {
      this.profiles.forEach((rsp) => {
        if (rsp.active) this.selected[rsp.source_identifier] = true
      })
    }
  },
  methods: {
    toggleTooltip(rspId) {
      this.tooltip[rspId] = !this.tooltip[rspId]
    },
    validateFee(ev) {
      const newFee = parseFloat(ev.target.value)
      if (newFee > 100 || newFee < 1) {
        this.fee = 0
      } else {
        this.fee = ev.target.value
      }
    },
    navigateNext() {
      this.$store.commit(APPLICATION_TEMPLATE_SET_NEW, {
        fee: this.fee,
        selected: Object.keys(this.selected)
          .map((key) => {
            return this.selected[key] ? key : ""
          })
          .filter(Boolean)
      })

      this.$router.push({ name: "dashboard_new_form_name" })
    },
    backToDashboard() {
      this.$router.push({ name: "dashboard_forms" })
    }
  }
}
</script>
